import { render, staticRenderFns } from "./ToolWebpage.vue?vue&type=template&id=18d8c0ce&scoped=true"
import script from "./ToolWebpage.vue?vue&type=script&lang=js"
export * from "./ToolWebpage.vue?vue&type=script&lang=js"
import style0 from "./ToolWebpage.vue?vue&type=style&index=0&id=18d8c0ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8c0ce",
  null
  
)

export default component.exports